import React from "react";
import { Button } from "../ui/button";

interface CardProps {
  tag: string;
  propertyType: string;
  location?: string;
  price: string;
  auctionDate: string;
  sellerName: string;
  sellerLogo: React.ReactNode;
  likeLogo: React.ReactNode;
  id: string;
  imageSrc: string;
  imageAlt?: string;
  onClickHandler?: any;
  styles?: {
    container?: string;
    imageContainer?: string;
    image?: string;
    textContainer?: string;
    propertyType?: string;
    location?: string;
    price?: string;
    auctionDateContainer?: string;
    auctionDateLabel?: string;
    auctionDateValue?: string;
    sellerContainer?: string;
    sellerLabel?: string;
    sellerName?: string;
    buttonContainer?: string;
    button?: string;
    buttonIndicator?: string;
    buttonText?: string;
    like?: string;
    tagContainer?: string;
    tag?: string;
  };
}

export default function GenericFeaturedCard({
  propertyType,
  location,
  price,
  auctionDate,
  sellerName,
  sellerLogo,
  likeLogo,
  id,
  imageSrc,
  imageAlt = "Property Image",
  onClickHandler,
  styles = {},
}: CardProps) {
  return (
    <div
      onClick={() => {
        onClickHandler(id);
      }}
      className={`bg-transparent max-w-[278px] cursor-pointer hover:shadow-lg hover:shadow-300 hover:duration-300 hover:ease-out ${styles.container}`}
    >
      {/* IMAGE part */}
      <div className="relative clip-path-mobileClipPolygonTopLeft">
        <section className={`flex w-full  ${styles.imageContainer || ""}`}>
          <img
            className={`max-w-[278px] z-0 ${styles.image}`}
            src={imageSrc}
            alt={imageAlt || "Product image"}
          />
        </section>
        <div
          className={`bg-brand-lightBlue absolute top-0 left-0 pl-20 py-[9px] pr-6 ${styles.tagContainer}`}
        >
          <p
            className={`text-center text-[8px] font-openSans font-semibold leading-normal tracking-[1.12px] text-brand-textBlack uppercase ${styles.tag}`}
          >
            FEATURED
          </p>
        </div>
        <div className={`absolute bottom-[6px] left-2 z-10 ${styles.like}`}>
          {likeLogo}
        </div>
      </div>

      <section className="border-brand-borderLightGray border-[1px]">
        {/* Text */}
        <div
          className={`pl-[13px] pr-[18px] pt-[6px] pb-[8px] flex ${
            styles.textContainer || ""
          }`}
        >
          <div className="pt-4">
            <p
              className={`font-openSans font-normal text-web-subheading leading-[27px] text-brand-textBlack capitalize ${
                styles.propertyType || ""
              }`}
            >
              {propertyType}
            </p>

            {location && (
              <p
                className={`font-openSans font-normal text-web-body-sm leading-[16px] text-brand-textGrey mt-[3px] ${
                  styles.location || ""
                }`}
              >
                {location}
              </p>
            )}
          </div>
          <p
            className={`font-openSans font-semibold text-web-subheading leading-[59px] text-brand-textBlack text-nowrap ml-auto ${
              styles.price || ""
            }`}
          >
            ₹ {price}
          </p>
        </div>
        {/* Border */}
        <div className="border-t-[1px] border-brand-borderLightGray"></div>

        {/* Auction Date */}
        <div
          className={`pl-[13px] pr-[18px] items-center flex py-[13px] mt-2 w-[258px] bg-gradient-to-r from-brand-lightOrange to-white rounded-tr-lg rounded-br-lg ${
            styles.auctionDateContainer || ""
          }`}
        >
          <p
            className={`text-brand-textGrey leading-4 text-web-body-sm font-normal font-openSans ${
              styles.auctionDateLabel || ""
            }`}
          >
            Auction date
          </p>
          <p
            className={`text-brand-textDarkBlack ml-auto text-web-body-sm font-normal font-openSans leading-4 ${
              styles.auctionDateValue || ""
            }`}
          >
            {auctionDate}
          </p>
        </div>
        <div
          className={`flex items-center gap-x-[9px] mx-auto h-[65px]  pl-[13px] pr-[18px] ${
            styles.sellerContainer || ""
          }`}
        >
          <span>{sellerLogo}</span>
          <div>
            <p
              className={`text-black text-[10px]  font-semibold font-openSans leading-4 capitalize mt-1 ${
                styles.sellerName || ""
              }`}
            >
              {sellerName}
            </p>
          </div>

          <Button
            variant={"outline"}
            size={"custom"}
            className={`h-[25px] w-[118px] rounded-[28px] ml-auto gap-x-2 ${
              styles.button || ""
            }`}
          >
            <div
              className={`bg-brand-orange h-[5px] w-[5px] rounded-full ${
                styles.buttonIndicator || ""
              }`}
            ></div>
            <p
              className={`font-openSans font-normal text-web-body-sm leading-[18px] text-brand-textGrey tracking-wider ${
                styles.buttonText || ""
              }`}
            >
              ID {id}
            </p>
          </Button>
        </div>
      </section>
    </div>
  );
}
